'use strict';

import { io, sub, base, Component, Store, PropTypes, uuid, cloneElement } from 'core';

/* jQuery stuffs */
import 'jquery-mousewheel';
//import 'jquery-mobile'; wut?

/* Velocity animations */
import 'velocity-animate';
import 'velocity-animate/velocity.ui';

/* Material definition */
import muiTheme from 'mui';

/**
 * Core Styles
 * Browser reset, helpers, functions, variables and aliases */
import $base from 'css/base.bundle';

/* Bootstrap overwrites  */
import $tbt from 'css/bootstrap.bundle';

/* App wrapper base styles  */
import $app from './style.bundle';

import initialState from 'state';

/**
 * App framework

 ** @Store key, initialState, default? =>
 *      extends edit() and define a new state tree

 ** @base ({ track, styles, bind }) =>
 *      Apply styles at mount/unmount
 *      Bind global events to mount/unmount
 *          eventKey: thisRef => handler
 *      Validates track props with shouldUpdate **/

@Store('app', initialState, true)
@base({
    bind: {
        'router:tear': $ => $.checkPage(),
        'router:tearup': $ => $.teardown(false),
        'router:teardown': $ => $.teardown(true),
        'ws:open': $ => $._set('mq', 'state', 'on'),
        'ws:close': $ => $._set('mq', 'state', 'off'),
        'ws:error': $ => $._set('mq', 'state', 'off')
    },
    track: [['router']]
})
class App extends Component {

    static childContextTypes = {
        muiTheme: PropTypes.object,
    }

    getChildContext = () => ({ muiTheme })

    state = { teardown: true }

    checkPage() {

        if (this.state.page !== this.props.location.pathname) {

            this.updatePage();

            setTimeout(() => this.teardown(false));
        }
    }
    updatePage() {
        const pathname = this.props.location.pathname

        setTimeout(() => this.setState({ page: pathname }));
        setTimeout(() => this._set('router', 'location', pathname));
    }
    teardown(value) {

        // Only updates to true
        if (!value && (this.state || {}).teardown !== value) {
            setTimeout(() => this.setState({ teardown: value }));
        }
    }

    firstStart() {

        setTimeout(_ => $('.pr-header-logo').css('top', '8px').css('animation', 'none'), 800);
        setTimeout(_ => this.teardown(false), 1100);
    }

    componentDidUpdate() {

        this.checkPage();
    }
    componentDidMount() {

        this.updatePage();

        io.emit('app:mounted');

        this.firstStart();
    }

    render() {

        const { edit, get, children } = this.props;
        const { teardown } = this.state || {};

        /* If page wrapper is provided: */
        const child = (children.page)
            ? cloneElement(children.page, {
                edit, get, children: children.component
            })
            : cloneElement(children, {
                edit, get
            });

        return (
  			<div className={ teardown ? "main main-content teardown" : "main main-content" }>
                { child }
            </div>
  		);
	}
};

export default App



// WEBPACK FOOTER //
// ./ui/c/index.jsx